import { get } from 'lodash';

export const selectBenefitPreviewCards = state => {
  return get(state, 'apps.employer-experience.benefitPreview.cards');
};
